import React from "react";
import { Carousel, Button } from "react-bootstrap";

const MyAllProjects = () => {
   return (
      <div
         className="bg-dark "
         style={{
            backgroundColor: "black",
            paddingTop: "150px",
            paddingBottom: "150px",
         }}
      >
         <h1 className=" text-white ">My Recent Projects</h1>
         <div
            style={{
               display: "flex",
               justifyContent: "center",
               alignItems: "center",
               paddingTop: "6px",
            }}
         >
            <p className="border-style"></p>
         </div>

         <div
            className="card mb-3 p-5 container"
            style={{
               maxWidth: "1500px",
               marginTop: "100px",
               backgroundColor: "#2C272E",
               border: "3px solid white",
            }}
         >
            <div className="row g-0">
               <div className="col-md-4">
                  <Carousel fade={true} pause={true}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/PgTd7mp/1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/FxF64d0/2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/WPGkntT/6.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/YcYf4Nq/3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/vzkZ8z9/4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/YhQ4gJz/5.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>
               </div>
               <div className="col-md-8">
                  <div className="card-body">
                     <h5
                        className="card-title"
                        style={{ textAlign: "left", color: "white" }}
                     >
                        NewBright Ecommerce
                     </h5>
                     <p
                        className="card-text"
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        <ul>
                           <li>
                              NewBright Ecommerce is a full-stack e-commerce web
                              site.
                           </li>
                           <li>
                              Implemented a firebase login system, private
                              routes, and a dashboard for admins and users.
                           </li>
                           <li>
                              Users can order products, admin can see their
                              orders and products in Dashboard.
                           </li>
                           <li>
                              Admin can manage products, update and delete
                              products.
                           </li>
                           <li>
                              Admin can create new, admins, users and can change
                              the status of users as an editor.
                           </li>
                        </ul>
                        <div>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase authentication
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                     </p>
                     <div style={{ textAlign: "left" }}>
                        <a
                           href="https://dashboard-ecommerce-f7a70.web.app/"
                           target="_blank"
                           className=""
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/dashboard-ecommerce"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div
            className="card mb-3 p-5 container"
            style={{
               maxWidth: "1500px",
               marginTop: "100px",
               backgroundColor: "#2C272E",
               border: "3px solid white",
            }}
         >
            <div className="row g-0">
               <div className="col-md-4">
                  <Carousel fade={true} pause={true}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/cQvCnpY/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/d62xJ61/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/MVM3TN8/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/VDmrSDj/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>
               </div>
               <div className="col-md-8">
                  <div className="card-body">
                     <h5
                        className="card-title"
                        style={{ textAlign: "left", color: "white" }}
                     >
                        Elegant Automobile
                     </h5>
                     <p
                        className="card-text"
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        <ul>
                           <li>
                              Elegent Automobile is a full-stack single-page car
                              sales service provider web app.
                           </li>
                           <li>
                              Login system with firebase, private routes and
                              dashboard for admins and users.
                           </li>
                           <li>
                              Users can order services, monitor their orderlist
                              and give a review, delete or pay the order.
                           </li>
                           <li>
                              Admin can add services, update and delete
                              services.
                           </li>
                           <li>
                              Admin can add new admins and can change the status
                              of orderlist.
                           </li>
                        </ul>
                        <div>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Material UI
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                     </p>
                     <div style={{ textAlign: "left" }}>
                        <a
                           href="https://elegent-automobile.web.app/"
                           target="_blank"
                           className=""
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/Elegent-Automobile-Front-End"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div
            className="card mb-3 p-5 container"
            style={{
               maxWidth: "1500px",
               marginTop: "200px",
               backgroundColor: "#2C272E",
               border: "3px solid white",
            }}
         >
            <div className="row g-0">
               <div className="col-md-4">
                  <Carousel fade={true} pause={true}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/1m0fPgv/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/0QFt44t/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/j8PLX4j/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/sm8QTn3/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>
               </div>
               <div className="col-md-8">
                  <div className="card-body">
                     <h5
                        className="card-title"
                        style={{ textAlign: "left", color: "white" }}
                     >
                        Travelious
                     </h5>
                     <p
                        className="card-text"
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        <ul>
                           <li>
                              A full-stack single-page travel service website.
                           </li>
                           <li>
                              Login system with firebase and private routes.
                           </li>
                           <li>
                              Clients can book services and see their booked
                              records on the booking page.
                           </li>
                           <li>
                              Clients can add services and can cancel or change
                              the status of the booking list using CRUD
                              operations.
                           </li>
                        </ul>
                        <div>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React-Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Node.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Express.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2 "
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              MongoDB
                           </span>
                        </div>
                     </p>

                     <div style={{ textAlign: "left" }}>
                        <a
                           href="https://travelious-react.web.app/"
                           target="_blank"
                           className=""
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/Travelious-Front-End"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div
            className="card mb-3 p-5 container"
            style={{
               maxWidth: "1500px",
               marginTop: "200px",
               backgroundColor: "#2C272E",
               border: "3px solid white",
            }}
         >
            <div className="row g-0">
               <div className="col-md-4">
                  <Carousel fade={true} pause={true} interval={2000}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/71TrqgG/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/nDScTPB/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/GCCh4CN/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/dB45zWr/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>
               </div>
               <div className="col-md-8">
                  <div className="card-body">
                     <h5
                        className="card-title"
                        style={{ textAlign: "left", color: "white" }}
                     >
                        Elderly Care
                     </h5>
                     <p
                        className="card-text"
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        <ul>
                           <li>
                              Eldery Care is a front-end Health Care Service
                              Provider web app.
                           </li>
                           <li>
                              Login system based on firebase and private routes.
                           </li>
                           <li>
                              Login and registration system with firebase
                              authentication and private routes.
                           </li>
                           <li>Clients can the single service information.</li>
                        </ul>
                        <div>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React-Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Router
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Hook
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Firebase
                           </span>
                        </div>
                     </p>
                     <div style={{ textAlign: "left" }}>
                        <a
                           href="https://eldery-care.web.app/"
                           target="_blank"
                           className="me-2 "
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/eldery-care-react"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div
            className="card mb-3 p-5 container"
            style={{
               maxWidth: "1500px",
               marginTop: "200px",
               backgroundColor: "#2C272E",
               border: "3px solid white",
            }}
         >
            <div className="row g-0">
               <div className="col-md-4">
                  <Carousel fade={true} pause={true} interval={2000}>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/LzKqd4r/Screenshot-1.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/zfXnT1h/Screenshot-2.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100 "
                           src="https://i.ibb.co/5c5KtJj/Screenshot-3.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                     <Carousel.Item>
                        <img
                           className="d-block w-100"
                           src="https://i.ibb.co/fqdgH5H/Screenshot-4.png"
                           alt="First slide"
                        />
                     </Carousel.Item>
                  </Carousel>
               </div>

               <div className="col-md-8">
                  <div className="card-body">
                     <h5
                        className="card-title"
                        style={{ textAlign: "left", color: "white" }}
                     >
                        Pyramid Architecture
                     </h5>
                     <p
                        className="card-text"
                        style={{ textAlign: "justify", color: "#C0C0C0" }}
                     >
                        <ul>
                           <li>
                              This website provides information about the
                              greatest Architectural Courses.
                           </li>
                           <li>
                              Users can see the courses and course details.
                           </li>
                           <li>Users can add the courses to the cart.</li>
                           <li>Users can review order and place order</li>
                        </ul>
                        <div>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React.js
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React-Bootstrap
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              CSS3
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              React Hook
                           </span>
                           <span
                              className="me-2 text-nowrap d-inline-block mt-2"
                              style={{
                                 border: "1px solid",
                                 padding: "5px",
                                 borderRadius: "5px",
                              }}
                           >
                              Storage API
                           </span>
                        </div>
                     </p>
                     <div style={{ textAlign: "left" }}>
                        <a
                           href="https://pyramid-architecture-react-abid.netlify.app/"
                           target="_blank"
                           className="me-2 "
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fas fa-external-link-alt"></i> Live Link
                           </Button>
                        </a>{" "}
                        <a
                           href="https://github.com/bakhtiarabid/pyramid-architecture-react"
                           target="_blank"
                        >
                           <Button className="btn-sm">
                              {" "}
                              <i class="fab fa-github"></i> GitHub
                           </Button>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
};

export default MyAllProjects;
